import { constants } from '..';

const setPhysicalCardsLoadingAction = flag => ({
  type: constants.physicalCards.SET_PHYSICAL_CARDS_LOADING,
  flag,
});

const getPhysicalCardsAction = body => ({
  type: constants.physicalCards.GET_PHYSICAL_CARDS,
  body,
});

const searchPhysicalCardsAction = query => ({
  type: constants.physicalCards.SEARCH_PHYSICAL_CARDS,
  query,
});

const setPhysicalCardsAction = (physicalCards, count) => ({
  type: constants.physicalCards.SET_PHYSICAL_CARDS,
  physicalCards,
  count,
});

const clearPhysicalCardsAction = () => ({
  type: constants.physicalCards.CLEAR_PHYSICAL_CARDS,
});

const addPhysicalCardAction = (body, history) => ({
  type: constants.physicalCards.ADD_PHYSICAL_CARD,
  body,
  history,
});

const getPhysicalCardAction = id => ({
  type: constants.physicalCards.GET_PHYSICAL_CARD,
  id,
});

const setPhysicalCardAction = selectedCard => ({
  type: constants.physicalCards.SET_PHYSICAL_CARD,
  selectedCard,
});

const clearPhysicalCardAction = () => ({
  type: constants.physicalCards.CLEAR_PHYSICAL_CARD,
});

const updatePhysicalCardAction = (id, body) => ({
  type: constants.physicalCards.UPDATE_PHYSICAL_CARD,
  id,
  body,
});

const addPhysicalCardDiscountAction = (id, body) => ({
  type: constants.physicalCards.ADD_PHYSICAL_CARD_DISCOUNT,
  id,
  body,
});

const setPhysicalCardDiscountErrorAction = error => ({
  type: constants.physicalCards.SET_PHYSICAL_CARD_DISCOUNT_ERROR,
  error,
});

const clearPhysicalCardDiscountErrorAction = () => ({
  type: constants.physicalCards.CLEAR_PHYSICAL_CARD_DISCOUNT_ERROR,
});

const topUpPhysicalCardAction = (id, body) => ({
  type: constants.physicalCards.TOP_UP_PHYSICAL_CARD,
  id,
  body,
});

const getPhysicalCardUsageAction = (id, params = {}) => ({
  type: constants.physicalCards.GET_PHYSICAL_CARD_USAGE,
  id,
  params,
});

const setPhysicalCardUsageAction = (usage, count) => ({
  type: constants.physicalCards.SET_PHYSICAL_CARD_USAGE,
  usage,
  count,
});

const clearPhysicalCardUsageAction = () => ({
  type: constants.physicalCards.CLEAR_PHYSICAL_CARD_USAGE,
});

const downloadPhysicalCardsImportTemplateAction = () => ({
  type: constants.physicalCards.DOWNLOAD_PHYSICAL_CARDS_IMPORT_TEMPLATE,
});

const setPhysicalCardsTemplateDownloadingAction = flag => ({
  type: constants.physicalCards.SET_PHYSICAL_CARDS_TEMPLATE_DOWNLOADING,
  flag,
});

const validatePhysicalCardsImportAction = file => ({
  type: constants.physicalCards.VALIDATE_PHYSICAL_CARDS_IMPORT,
  file,
});

const setPhysicalCardsImportValidatingAction = flag => ({
  type: constants.physicalCards.SET_PHYSICAL_CARDS_IMPORT_VALIDATING,
  flag,
});

const setPhysicalCardsImportBatchAction = importBatch => ({
  type: constants.physicalCards.SET_PHYSICAL_CARDS_IMPORT_BATCH,
  importBatch,
});

const clearPhysicalCardsImportAction = () => ({
  type: constants.physicalCards.CLEAR_PHYSICAL_CARDS_IMPORT,
});

const commitPhysicalCardsImportAction = batchId => ({
  type: constants.physicalCards.COMMIT_PHYSICAL_CARDS_IMPORT,
  batchId,
});

const setPhysicalCardsImportCommittingAction = flag => ({
  type: constants.physicalCards.SET_PHYSICAL_CARDS_IMPORT_COMMITTING,
  flag,
});

const setPhysicalCardsImportCommitResultAction = importCommitResult => ({
  type: constants.physicalCards.SET_PHYSICAL_CARDS_IMPORT_COMMIT_RESULT,
  importCommitResult,
});

const downloadPhysicalCardsImportFailedRowsAction = batchId => ({
  type: constants.physicalCards.DOWNLOAD_PHYSICAL_CARDS_IMPORT_FAILED_ROWS,
  batchId,
});

export const physicalCardsActions = {
  setPhysicalCardsLoadingAction,
  getPhysicalCardsAction,
  searchPhysicalCardsAction,
  setPhysicalCardsAction,
  clearPhysicalCardsAction,
  addPhysicalCardAction,
  getPhysicalCardAction,
  setPhysicalCardAction,
  clearPhysicalCardAction,
  updatePhysicalCardAction,
  addPhysicalCardDiscountAction,
  setPhysicalCardDiscountErrorAction,
  clearPhysicalCardDiscountErrorAction,
  topUpPhysicalCardAction,
  getPhysicalCardUsageAction,
  setPhysicalCardUsageAction,
  clearPhysicalCardUsageAction,
  downloadPhysicalCardsImportTemplateAction,
  setPhysicalCardsTemplateDownloadingAction,
  validatePhysicalCardsImportAction,
  setPhysicalCardsImportValidatingAction,
  setPhysicalCardsImportBatchAction,
  clearPhysicalCardsImportAction,
  commitPhysicalCardsImportAction,
  setPhysicalCardsImportCommittingAction,
  setPhysicalCardsImportCommitResultAction,
  downloadPhysicalCardsImportFailedRowsAction,
};
